import React from "react";
import PropTypes from "prop-types";
import helpText from "../data/helpText";

/**
 * Optional help text for a field. Ported from GSA openacr-editor HelpText.svelte.
 */
export default function HelpText({ type, field }) {
  const text = helpText[type]?.[field];
  if (!text) return null;
  return (
    <span className="help-text block text-gray-500 italic text-sm mt-1">
      {text}
    </span>
  );
}

HelpText.propTypes = {
  type: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired,
};
